/* Copyright 2016-2020 The MathWorks, Inc. */
define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/IconProperty",
        "../properties/QuickAccessIconProperty",
        "../properties/IconOverrideProperty",
        "../properties/TextProperty",
        "../properties/TextOverrideProperty",
        "../properties/EnabledProperty",
        "../properties/DescriptionProperty",
        "../properties/DescriptionOverrideProperty",
        "../properties/MnemonicProperty",
        "../properties/ShortcutProperty",
        "../properties/ActionIdProperty",
        "../properties/IsInQABProperty",
        "../../../constants/RecentColorsMode",
        "../../../constants/SwatchColorMode"  
    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, IconProperty, QuickAccessIconProperty,
              IconOverrideProperty, TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty,
              MnemonicProperty, ShortcutProperty, ActionIdProperty, IsInQABProperty, RecentColorsMode, SwatchColorMode) {
        var hash = {};

        hash[TypeConstants.COLOR_PICKER_BUTTON] = lang.mixin({}, {

                selectedColor: {
                    type: "string",
                    defaultValue: "#ff0000",
                    notInAction: true,
                    required: false
                },

                recentlyUsedColors: {
                    type: "Array",
                    defaultValue: ['#ff0000', '#ff00ff', '#ffff00', '#00ff00', '#ffffff', '#00ffff', '#0000ff'],
                    notInAction: true,
                    required: false
                },

                recentColorsTitle: {
                    type: "string",
                    defaultValue: "Recent Colors",
                    notInAction: true,
                    required: false
                },

                recentColorsMode: {
                    type: "string",
                    defaultValue: RecentColorsMode.DEFAULT,
                    notInAction: true,
                    required: false
                },

                closeOnColorSelection: {
                    type: "boolean",
                    defaultValue: true,
                    notInAction: true,
                    required: false
                },

                autoColor: {
                    type: "string",
                    defaultValue: "#000000",
                    notInAction: true,
                    required: false
                },

                displayView: {
                    type: "string",
                    defaultValue: "standard",
                    notInAction: true,
                    required: false
                },

                showAuto: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                },

                showNone: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                },

                showFlat: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                },

                showInterp: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                },

                showTexturemap: {
                    type: "boolean",
                    defaultValue: false,
                    notInAction: true,
                    required: false
                },

                swatchColor: {
                    type: "string",
                    defaultValue: "#000000",
                    notInAction: true,
                    required: false
                },

                swatchColorMode: {
                    type: "string",
                    defaultValue: SwatchColorMode.AUTO,
                    notInAction: true,
                    required: false
                }

            }, TypeProperty, TagProperty, IconProperty,
            QuickAccessIconProperty, IconOverrideProperty, TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty,
            MnemonicProperty, ShortcutProperty, ActionIdProperty, IsInQABProperty);

        return hash;
    });
